/**
 * Toggle-button group rendered inside the unified `DataViewFilterPanel`'s
 * footer for tab-style filters. Driven by an `ExceptionFilterStripDef` of
 * `type: 'tabs'`.
 *
 * Currently the SK-LS invoice-sync page uses this for Active / Fixed.
 * The label callbacks are responsible for any count badges so the
 * config retains sole ownership of which response field feeds which
 * tab's count.
 *
 * The component contributes only the `ToggleButtonGroup` - the panel
 * owns positioning (footer-left slot) and surrounding chrome.
 */
import React from 'react'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'

interface ExceptionFilterTabsProps {
  paramKey: string
  tabs: Array<{
    value: string
    renderLabel: (response: Record<string, any> | null, activeValue: string) => string
  }>
  activeValue: string
  response: Record<string, any> | null
  onChange: (value: string) => void
}

const ExceptionFilterTabs: React.FC<ExceptionFilterTabsProps> = ({
  paramKey,
  tabs,
  activeValue,
  response,
  onChange,
}) => {
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={activeValue}
      onChange={(_e, v) => {
        if (typeof v === 'string') onChange(v)
      }}
      aria-label={paramKey}
    >
      {tabs.map((tab) => (
        <ToggleButton key={tab.value} value={tab.value}>
          {tab.renderLabel(response, activeValue)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}

export default ExceptionFilterTabs
